/** Smena hisobi (test: time.test.ts): xodimning o'z zonasida boshlanish/tugash, tunga o'tadigan smena ham (18:00-03:00). */

export interface ShiftState {
  phase: "before" | "during" | "after";
  /** O'tgan ulush 0..1 (smena vaqtida), aks holda 0 */
  fraction: number;
  elapsedMin: number;
  remainingMin: number;
  /** Boshlanishigacha daqiqa (smena vaqtidan tashqarida) */
  untilStartMin: number;
  lengthMin: number;
}

const fmtCache = new Map<string, Intl.DateTimeFormat>();

/** Zona bo'yicha kun ichidagi daqiqa (0..1439) */
export function minuteOfDay(now: Date, tz: string): number {
  let f = fmtCache.get(tz);
  if (!f) {
    f = new Intl.DateTimeFormat("en-US", { timeZone: tz, hourCycle: "h23", hour: "numeric", minute: "numeric" });
    fmtCache.set(tz, f);
  }
  const parts = Object.fromEntries(f.formatToParts(now).map((p) => [p.type, p.value]));
  return (Number(parts.hour) % 24) * 60 + Number(parts.minute);
}

export const parseHM = (s: string): number => {
  const [h, m] = s.split(":").map(Number);
  return (h % 24) * 60 + (m % 60);
};

export function shiftState(now: Date, tz: string, start: string, end: string): ShiftState {
  const m = minuteOfDay(now, tz);
  const s = parseHM(start);
  const e = parseHM(end);
  const length = (e - s + 1440) % 1440 || 1440;
  const since = (m - s + 1440) % 1440; // boshlanishdan beri (aylanma, tunga o'tsa ham)
  if (since < length) {
    return { phase: "during", fraction: since / length, elapsedMin: since, remainingMin: length - since, untilStartMin: 0, lengthMin: length };
  }
  // Tashqarida: tugaganidan beri o'tgan vaqt bo'shliqning yarmidan kam bo'lsa "tugadi", aks holda "hali boshlanmagan"
  const gap = 1440 - length;
  const sinceEnd = since - length;
  return { phase: sinceEnd < gap / 2 ? "after" : "before", fraction: 0, elapsedMin: 0, remainingMin: 0, untilStartMin: 1440 - since, lengthMin: length };
}

/** "2:15" -- soat:daqiqa */
export const hm = (minutes: number): string => `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}`;
